module.exports = __webpack_public_path__ + "04_long_yellow.c433bda6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/04_long_yellow.png
// module id = Kzjm
// module chunks = 0